// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.ratings-table-wrapper {
  max-height: 600px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.view-only-rating {
  border-radius: 5px;
  height: 32px;
  width: 83%;
  display: flex;
  align-items: center;
  padding-left: 4px;
  color: black;
}

.rating-green {
  background-color: #C7CC68;
}

.rating-orange {
  background-color: #FEBF31;
}

.rating-red {
  background-color: #e27319;
}

.rating-excluded {
  background-color: #444343;
  color: white;
  width: stretch;
}

.hierarchy-text-wrapper {
  font-size: 0.8rem;
}

.hierarchy-text {
  font-weight: 600;
  margin-bottom: 4px;
  margin-right: 8px;
}

.plo-wrapper {
  background-color: #F1F4F6;
  border: 1px solid #808080;
  border-radius: 5px;
  padding: 12px;
}

.plo-section {
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 16;
  margin-top: 8px;
}

.plo-title {
  font-weight: 700;
  margin-right: 8px;
}

.save-btn-ratings {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  width: 100%;
}

.content-type-section-title {
  background: linear-gradient(to right, #c0def0 70%, #ffffff 100%);
  border-radius: 3px;
  color: #0A4064;
  font-size: 22px;
  font-weight: 600;
  margin: 0.5rem 0rem 1rem 0rem;
  padding: 8px 16px;
}

.grade-label {
  display: inline-block;
  font-size: 20px;
  font-weight: 600;
  margin-left: 8px;
  white-space: nowrap;
}

.item-card {
  background: white;
  border: 1px solid #A7A9AC;
  border-radius: 10px;
  box-shadow: 0 1px 3px #A7A9AC;
  margin-bottom: 12px;
  padding: 16px;
  white-space: pre-line;
}

.sle-child-card {
  background: white;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: space-between;
  margin: 8px -5px 8px 32px;
  padding: 8px 5px 8px 10px;
  white-space: pre-line;
}

.previous-semester-rating {
  font-size: 0.875rem;
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: white;
  border: 1.5px solid;
  color: black;
  width: stretch;
  margin-left: 24px;
}
.previous-semester-rating::before {
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 2px;
  flex-shrink: 0;
}
.previous-semester-rating.rating-blue {
  border-color: #1179ef;
}
.previous-semester-rating.rating-blue::before {
  background-color: #1179ef;
}
.previous-semester-rating.rating-green {
  border-color: #C7CC68;
}
.previous-semester-rating.rating-green::before {
  background-color: #C7CC68;
}
.previous-semester-rating.rating-orange {
  border-color: #FEBF31;
}
.previous-semester-rating.rating-orange::before {
  background-color: #FEBF31;
}
.previous-semester-rating.rating-red {
  border-color: #e27319;
}
.previous-semester-rating.rating-red::before {
  background-color: #e27319;
}
.previous-semester-rating.rating-excluded {
  border-color: #2d2d2d;
}
.previous-semester-rating.rating-excluded::before {
  background-color: #2d2d2d;
}
.previous-semester-rating .comment-icon {
  font-size: 0.875rem;
  cursor: pointer;
  color: inherit;
}

.picker-wrapper {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/RatingsList.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AADA;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAIJ;;AADA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AAIJ;;AADA;EACI,yBAvBW;AA2Bf;;AADA;EACI,yBDRQ;ACYZ;;AADA;EACI,yBA7BS;AAiCb;;AADA;EACI,yBDPK;ECQL,YAAA;EACA,cAAA;AAIJ;;AADA;EACI,iBAAA;AAIJ;;AADA;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AAIJ;;AADA;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,OAAA;EACA,eAAA;AAIJ;;AADA;EACI,gBAAA;EACA,iBAAA;AAIJ;;AADA;EACI,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;AAIJ;;AAAA;EACI,gEAAA;EACA,kBAAA;EACA,cD5EM;EC6EN,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,iBAAA;AAGJ;;AAAA;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAGJ;;AAAA;EACI,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,qBAAA;AAGJ;;AAAA;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AAGJ;;AAAA;EACI,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AAGJ;AADI;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAGR;AAAI;EACI,qBA9IM;AAgJd;AAAQ;EACI,yBAjJE;AAmJd;AAEI;EACI,qBArJO;AAqJf;AAEQ;EACI,yBAxJG;AAwJf;AAII;EACI,qBD1II;ACwIZ;AAIQ;EACI,yBD7IA;AC2IZ;AAMI;EACI,qBAnKK;AA+Jb;AAMQ;EACI,yBAtKC;AAkKb;AAQI;EACI,qBAAA;AANR;AAQQ;EACI,yBAAA;AANZ;AAUI;EACI,mBAAA;EACA,eAAA;EACA,cAAA;AARR;;AAYA;EACI,qBAAA;EACA,aAAA;EACA,sBAAA;AATJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n$rating-blue: #1179ef;\n$rating-green: #C7CC68;\n$rating-orange: $important;\n$rating-red: #e27319;\n\n\n.ratings-table-wrapper {\n    max-height: 600px;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.view-only-rating {\n    border-radius: 5px;\n    height: 32px;\n    width: 83%;\n    display: flex;\n    align-items: center;\n    padding-left: 4px;\n    color: black;\n}\n\n.rating-green {\n    background-color: $rating-green;\n}\n\n.rating-orange {\n    background-color: $rating-orange;\n}\n\n.rating-red {\n    background-color: $rating-red;\n}\n\n.rating-excluded {\n    background-color: $grey4a;\n    color: white;\n    width: stretch;\n}\n\n.hierarchy-text-wrapper {\n    font-size: 0.8rem;\n}\n\n.hierarchy-text {\n    font-weight: 600;\n    margin-bottom: 4px;\n    margin-right: 8px;\n}\n\n.plo-wrapper {\n    background-color: #F1F4F6;\n    border: 1px solid $grey3;\n    border-radius: 5px;\n    padding: 12px\n}\n\n.plo-section {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    gap: 16;\n    margin-top: 8px;\n}\n\n.plo-title {\n    font-weight: 700;\n    margin-right: 8px;\n}\n\n.save-btn-ratings {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 16px;\n    width: 100%;\n}\n\n\n.content-type-section-title {\n    background: linear-gradient(to right, #c0def0 70%, #ffffff 100%);\n    border-radius: 3px;\n    color: $dk-blue;\n    font-size: 22px;\n    font-weight: 600;\n    margin: 0.5rem 0rem 1rem 0rem;\n    padding: 8px 16px;\n}\n\n.grade-label {\n    display: inline-block;\n    font-size: 20px;\n    font-weight: 600;\n    margin-left: 8px;\n    white-space: nowrap;\n}\n\n.item-card {\n    background: white;\n    border: 1px solid $grey2;\n    border-radius: 10px;\n    box-shadow: 0 1px 3px $grey2;\n    margin-bottom: 12px;\n    padding: 16px;\n    white-space: pre-line;\n}\n\n.sle-child-card {\n    background: white;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    justify-content: space-between;\n    margin: 8px -5px 8px 32px;\n    padding: 8px 5px 8px 10px;\n    white-space: pre-line;\n}\n\n.previous-semester-rating {\n    font-size: 0.875rem;\n    margin-top: 6px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 8px;\n    border-radius: 4px;\n    background-color: white;\n    border: 1.5px solid;\n    color: black;\n    width: stretch;\n    margin-left: 24px;\n\n    &::before {\n        content: '';\n        width: 12px;\n        height: 12px;\n        border-radius: 2px;\n        flex-shrink: 0;\n    }\n\n    &.rating-blue {\n        border-color: $rating-blue;\n\n        &::before {\n            background-color: $rating-blue;\n        }\n    }\n\n    &.rating-green {\n        border-color: $rating-green;\n\n        &::before {\n            background-color: $rating-green;\n        }\n    }\n\n    &.rating-orange {\n        border-color: $rating-orange;\n\n        &::before {\n            background-color: $rating-orange;\n        }\n    }\n\n    &.rating-red {\n        border-color: $rating-red;\n\n        &::before {\n            background-color: $rating-red;\n        }\n    }\n\n    &.rating-excluded {\n        border-color: #2d2d2d;\n\n        &::before {\n            background-color: #2d2d2d;\n        }\n    }\n\n    .comment-icon {\n        font-size: 0.875rem;\n        cursor: pointer;\n        color: inherit;\n    }\n}\n\n.picker-wrapper {\n    align-items: flex-end;\n    display: flex;\n    flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
